import React from 'react';
import { Box, Dialog, DialogTitle, DialogContent, Typography, makeStyles } from '@applyboard/ui-components';
import CloseButtonCore from "../CloseButton/CloseButtonCore";
var useStyles = makeStyles({
  closeButton: {
    position: 'absolute',
    right: '20px',
    top: '25px'
  }
});
var ConditionalAcceptanceDialog = function ConditionalAcceptanceDialog(props) {
  var open = props.open,
    onClose = props.onClose,
    text = props.text;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Dialog, {
    PaperProps: {
      style: {
        borderRadius: 10
      }
    },
    "aria-labelledby": "conditional-acceptance-modal-title",
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: "conditional-acceptance-modal-title"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "row"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    mr: "20px"
  }, "What is an ESL course?")), /*#__PURE__*/React.createElement(Box, {
    className: classes.closeButton
  }, /*#__PURE__*/React.createElement(CloseButtonCore, {
    onClick: onClose
  })))), /*#__PURE__*/React.createElement(DialogContent, {
    dividers: true
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, text))));
};
export default ConditionalAcceptanceDialog;